module.exports = __webpack_public_path__ + "img/课程介绍_07.c1903d23.jpg";